import React from 'react';
import PropTypes from 'prop-types';

import { ToggleButton } from '../../../../components/index';
import './style.sass';

const NotificationPreferences = ({ t }) => (
  <div className="notification-preferences">
    <ul className="notification-preferences__list">
      <li className="notification-preferences__item">
        <div className="notification-preferences__label">{t('Mute')}</div>
        <ToggleButton />
      </li>
    </ul>
  </div>
);

NotificationPreferences.propTypes = {
  t: PropTypes.func.isRequired,
};

export default NotificationPreferences;
